import { memo, useEffect, useRef } from "react";
import { cn } from "../../lib/utils";

const GlowingEffect = memo(({ spread = 20, blur = 0, borderWidth = 1, className }) => {
  const containerRef = useRef(null);
  const rafRef = useRef(null);
  const angleRef = useRef(270);

  useEffect(() => {
    const el = containerRef.current;
    if (!el) return;

    el.style.setProperty("--active", "1");

    const tick = () => {
      angleRef.current = (angleRef.current + 0.4) % 360;
      el.style.setProperty("--start", String(angleRef.current));
      rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, []);

  return (
    <div
      ref={containerRef}
      style={{
        "--blur": `${blur}px`,
        "--spread": spread,
        "--start": "270",
        "--active": "1",
        "--glowingeffect-border-width": `${borderWidth}px`,
        "--repeating-conic-gradient-times": "5",
        "--gradient": `radial-gradient(circle, #a855f7 10%, #a855f700 20%),
          radial-gradient(circle at 40% 40%, #ec4899 5%, #ec489900 15%),
          radial-gradient(circle at 60% 60%, #06b6d4 10%, #06b6d400 20%),
          radial-gradient(circle at 40% 60%, #10b981 10%, #10b98100 20%),
          repeating-conic-gradient(
            from 236.84deg at 50% 50%,
            #a855f7 0%,
            #ec4899 calc(25% / var(--repeating-conic-gradient-times)),
            #06b6d4 calc(50% / var(--repeating-conic-gradient-times)),
            #10b981 calc(75% / var(--repeating-conic-gradient-times)),
            #a855f7 calc(100% / var(--repeating-conic-gradient-times))
          )`,
      }}
      className={cn(
        "pointer-events-none absolute inset-0 rounded-[inherit]",
        blur > 0 && "blur-[var(--blur)]",
        className
      )}
    >
      <div
        className={cn(
          "glow rounded-[inherit]",
          "after:content-[''] after:rounded-[inherit] after:absolute after:inset-[calc(-1*var(--glowingeffect-border-width))]",
          "after:[border:var(--glowingeffect-border-width)_solid_transparent]",
          "after:[background:var(--gradient)] after:[background-attachment:fixed]",
          "after:opacity-[var(--active)] after:transition-opacity after:duration-300",
          "after:[mask-clip:padding-box,border-box]",
          "after:[mask-composite:intersect]",
          "after:[mask-image:linear-gradient(#0000,#0000),conic-gradient(from_calc((var(--start)-var(--spread))*1deg),#00000000_0deg,#fff,#00000000_calc(var(--spread)*2deg))]"
        )}
      />
    </div>
  );
});

GlowingEffect.displayName = "GlowingEffect";

export { GlowingEffect };
